import { TValidTestId } from 'types/context-role-element.types';
import ConfirmEmailPageContext from './confirm-email-page';
import LoginPageContext from './login-page';
import LogoutPageContext from './logout-page';
import MfaPageContext from './mfa-page';
import NewPasswordPageContext from './new-password-page';
import RecoverEmailPageContext from './recover-email-page';
import RecoverPasswordPageContext from './recover-password-page';
import RegisterPageContext from './register-page';
import VerifyPageContext from './verify-page';

export default {
  ...ConfirmEmailPageContext,
  ...LoginPageContext,
  ...LogoutPageContext,
  ...MfaPageContext,
  ...NewPasswordPageContext,
  ...RecoverEmailPageContext,
  ...RecoverPasswordPageContext,
  ...RegisterPageContext,
  ...VerifyPageContext,
} as TValidTestId;
